import React, { useState } from 'react';

import { ButtonV2 } from 'components/common/ui';
import { InputFieldV2 } from 'components/common/form-controls';
import { showError } from '@utils';
import { ModalFooter, ModalV2 } from 'components/common/modals';

const ToggleServicePointStatus = ({
  servicePointId,
  onToggleStatus,
  isActive,
  servicePointName,
}) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [updating, setUpdating] = useState(false);

  const handleToggleStatus = async () => {
    try {
      setUpdating(true);
      const payload = {
        servicePointsIds: [servicePointId],
        status: isActive ? 0 : 1,
      };
      await onToggleStatus(payload);
    } catch (error) {
      showError(error);
    } finally {
      setUpdating(false);
      setModalIsOpen(false);
    }
  };

  const handleCloseModal = () => {
    setModalIsOpen(false);
  };

  const handleOpenModal = () => {
    setModalIsOpen(true);
  };

  return (
    <>
      <InputFieldV2
        type="switch"
        value={isActive}
        onChange={isActive ? handleOpenModal : handleToggleStatus}
      />
      <ModalV2
        isOpen={modalIsOpen}
        onClose={handleCloseModal}
        title="Deactivate Service Point?"
        maxWidth="sm"
      >
        Are you sure you want to deactivate the service point {servicePointName}
        <ModalFooter>
          <ButtonV2
            variant="secondary"
            onClick={handleCloseModal}
            loading={updating}
          >
            Cancel
          </ButtonV2>
          <ButtonV2 onClick={handleToggleStatus} loading={updating}>
            Deactivate
          </ButtonV2>
        </ModalFooter>
      </ModalV2>
    </>
  );
};

export default ToggleServicePointStatus;
